import { useTranslation } from 'next-i18next';
import { TabsList, TabsTrigger } from '@zep/ui/experimental';
import { cn } from '@zep/utils';
import { usePricingLocale } from '../hooks';
export const PaymentTypeTabs = () => {
  const {
    t
  } = useTranslation(['subscription']);
  const pricingLocale = usePricingLocale();
  // VAT 안내 문구는 일반 안내(사전 고지)일 뿐이다 — notice 표시 여부가
  // 결제 금액 계산에 관여하면 안 된다 (notice visibility != VAT applicability).
  // 실제 과세/금액은 서버 snapshot과 결제 화면의 vatAmount가 결정한다.
  // 정책 시각(2026-06-18 09:00 KST) 전에도 사전 안내 목적으로 노출을 유지한다.
  const showVat = pricingLocale === 'ko';
  return <div className="flex w-full items-end justify-between py-[30px]" data-sentry-component="PaymentTypeTabs" data-sentry-source-file="PaymentTypeTabs.tsx">
      <div className="w-[140px]" />
      <TabsList className="flex h-[38px] w-fit flex-row items-center gap-px rounded-full border border-[#27262E0A] bg-gray-200 p-[2px]" data-sentry-element="TabsList" data-sentry-source-file="PaymentTypeTabs.tsx">
        <TabsTrigger value="monthly-pay" className={cn('m-0 h-[34px] !text-[13px] text-body-2 font-[600] rounded-full hover:bg-[#27262E14] px-[14px]', 'data-[state=active]:bg-white', 'data-[state=active]:text-gray-900', 'data-[state=active]:shadow-[0_2px_10px_0_rgba(42,39,65,0.10)]')} data-sentry-element="TabsTrigger" data-sentry-source-file="PaymentTypeTabs.tsx">
          {t('subscription:pricing.monthly', '월간 결제')}
        </TabsTrigger>
        <TabsTrigger value="yearly-pay" className={cn('flex gap-[4px] !text-[13px] text-body-2 font-[600] items-center m-0 h-[34px] rounded-full hover:bg-[#27262E14] px-[14px]', 'data-[state=active]:bg-white', 'data-[state=active]:text-gray-900', 'data-[state=active]:shadow-[0_2px_10px_0_rgba(42,39,65,0.10)]')} data-sentry-element="TabsTrigger" data-sentry-source-file="PaymentTypeTabs.tsx">
          {t('subscription:pricing.annual', '연간 결제')}
          <span className={cn('rounded-[3px] bg-gradient-to-br from-[#FF7874] to-[#FF9A5C] px-[4px] text-[11px] font-[700] text-white', 'leading-[20px]')}>
            {t('subscription:pricing.discount', {
            defaultValue: '최대 30% 할인',
            amount: '30%'
          })}
          </span>
        </TabsTrigger>
      </TabsList>
      {showVat ? <span className="text-[13px] font-[500] leading-[18.2px] text-[#7A7B89]">
          {t('subscription:pricing.vatNotice', '*부가세(VAT 10%) 별도')}
        </span> : <div />}
    </div>;
};